import { render } from "./email-campaign-edit.vue?vue&type=template&id=329aa0ab"
import script from "./email-campaign-edit.vue?vue&type=script&lang=js"
export * from "./email-campaign-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__